module.exports = __webpack_public_path__ + "static/media/DIFFAVIG.50ff6b6a.png";